export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "org_invoice_discount": {
            "discount_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "discount_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de descuento"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto"])},
            "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descripción"])},
            "discount_percent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Porcentaje de descuento"])},
            "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moneda"])},
            "exchange_rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de cambio"])}
          }
        }
      },
      "en": {
        "model": {
          "org_invoice_discount": {
            "discount_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discount date"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amount"])},
            "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
            "discount_percent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discount percent"])},
            "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency"])},
            "exchange_rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exchange rate"])}
          }
        }
      }
    }
  })
}